"use client";

import { Copy } from "lucide-react";
import { toast } from "@/lib/toast";

interface CopyButtonProps {
  text: string;
  tooltip?: string;
  successText?: string;
  testId?: string;
}

export function CopyButton({
  text,
  tooltip,
  successText,
  testId,
}: CopyButtonProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      if (successText) toast.success(successText);
    } catch {
      toast.error("Failed to copy");
    }
  };

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        handleCopy();
      }}
      aria-label={tooltip ?? "Copy"}
      title={tooltip}
      data-testid={testId}
      className="group relative inline-flex shrink-0 cursor-pointer items-center border-0 bg-transparent p-0 p-0.5 outline-none"
    >
      <Copy className="size-2.5 opacity-60 transition-opacity duration-150 group-hover:opacity-100" />
    </button>
  );
}
